import type { IconData } from '@stacksjs/iconify-core'

export const spotify: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M37 20.374c-3.215-2.473-7.355-3.872-11.549-4.261c-4.174-.387-8.582.21-12.451 1.925m20.54 8.637c-2.536-1.998-5.812-3.13-9.13-3.443c-3.389-.32-6.974.198-10.088 1.673M30.049 33c-1.854-1.51-4.251-2.364-6.68-2.6c-2.415-.235-4.968.13-7.203 1.179\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default spotify
